/* tslint:disable */
/* eslint-disable */
/**
 * Vividi Dashboard API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetLocalityCapacityRequestBody
 */
export interface SetLocalityCapacityRequestBody {
    /**
     * 
     * @type {number}
     * @memberof SetLocalityCapacityRequestBody
     */
    capacity: number;
}

export function SetLocalityCapacityRequestBodyFromJSON(json: any): SetLocalityCapacityRequestBody {
    return SetLocalityCapacityRequestBodyFromJSONTyped(json, false);
}

export function SetLocalityCapacityRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetLocalityCapacityRequestBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'capacity': json['capacity'],
    };
}

export function SetLocalityCapacityRequestBodyToJSON(value?: SetLocalityCapacityRequestBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'capacity': value.capacity,
    };
}

